// src/registerServiceWorker.js
if ('serviceWorker' in navigator) {
  // Ускоряем установку в standalone
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch((e) => console.error('SW register failed', e))
  })

  // Опционально: слушаем обновления и предлагаем перезагрузку
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    // когда новый SW активировался, можно мягко перезагрузить UI
    // location.reload(); // если хочешь авто-рефреш
  })
}
